import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto bg-[#0a1628] border-t border-[#1e3a5f]/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="/assets/logo-new.png" 
                alt="Next Fiber Networks Logo" 
                className="h-14 w-auto object-contain"
              />
              <div className="flex flex-col">
                <span className="font-bold text-xl text-[#f1f5f9]">Next Fiber Networks</span>
                <span className="text-sm text-[#3b82f6] font-medium">Building Networks. Building Futures.</span>
              </div>
            </div>
            <p className="text-[#94a3b8] text-sm leading-relaxed max-w-md mb-6">
              Professional fiber splicing, tower deployment, and telecom education services. 
              Empowering the next generation of telecommunications professionals.
            </p>
            <div className="flex gap-3">
              <a
                href="https://linkedin.com/company/next-fiber-networks"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 rounded-lg bg-[#162544] text-[#94a3b8] hover:text-[#3b82f6] hover:bg-[#1e3a5f] transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-[#f1f5f9] mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { to: '/', label: 'Home' },
                { to: '/services', label: 'Services' },
                { to: '/education', label: 'Education' },
                { to: '/advisory', label: 'Advisory' },
                { to: '/contact', label: 'Contact' }
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-sm text-[#94a3b8] hover:text-[#3b82f6] transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-[#f1f5f9] mb-6">Services</h3>
            <ul className="space-y-3 text-sm text-[#94a3b8]">
              <li>Fiber Splicing</li>
              <li>Tower Site Deployment</li>
              <li>Field Verification</li>
              <li>Education Seminars</li>
              <li>Technical Advisory</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#1e3a5f]/50">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#64748b]">
              &copy; {currentYear} Next Fiber Networks. All rights reserved.
            </p>
            <p className="text-sm text-[#3b82f6] font-medium">
              Building Networks. Building Futures.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
